@app.controller 'JouleAppMainHeroController', (mobileDetectionService, responsiveService) ->

  @isMobileDevice = mobileDetectionService.isMobile
  @isViewportMobile = responsiveService.isViewportMobile()
  @showDesktopImage = responsiveService.isViewportGT(500)
  @youtubeId = '9D-Btpd0_rY'
  @image = 'https://d3awvtnmmsvyot.cloudfront.net/api/file/3yRy3rarRsmzSl9DTZj7'
  @mobileImage = 'https://d3awvtnmmsvyot.cloudfront.net/api/file/iZ5sj1ePQRCFMzbXtDFJ'
  this
